module.exports = __webpack_public_path__ + "img/sxwt.ba404117.png";